import cs from './cs.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import hi from './hi.json';
import it from './it.json';
import ko from './ko.json';
import pl from './pl.json';
import pt from './pt.json';
import tr from './tr.json';
import uk from './uk.json';
import uz from './uz.json';
import zh from './zh.json';

const translations = { cs, de, en, es, hi, it, ko, pl, pt, tr, uk, uz, zh };

export default translations;
